<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <welcomecard />
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="card">
      <div v-if="is_authorization === null" class="card-body">
        <div class="d-flex justify-content-center">
          authorization checking...
        </div>
      </div>
      <div v-if="is_authorization === 'N'" class="card-body">
        <div class="d-flex justify-content-center text-danger">
          <b>คุณไม่มีสิทธิ์เข้าถึงหน้านี้</b>
        </div>
      </div>

      <div v-if="is_authorization === 'Y'" class="card-body">

        <!-- Header -->
        <div class="card mb-4">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0"><b>ตั้งค่าระบบ (Admin Utils)</b></h5>
              <router-link to="/dashboard-admin" class="btn btn-outline-secondary">
                <vue-feather type="arrow-left" size="16"></vue-feather> กลับหน้า Admin
              </router-link>
            </div>
          </div>
        </div>

        <!-- Section 1: Clear Cache -->
        <div class="card mb-4">
          <div class="card-header">
            <h5 class="m-0"><b>1. Clear Cache</b></h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-12">
                <label class="form-label fw-bold">ประเภทการ Clear</label>
                <div class="d-flex gap-3 flex-wrap">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="cacheAll" v-model="cache.type" value="ALL" />
                    <label class="form-check-label" for="cacheAll">ALL (ล้างทุก cache)</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="cacheTargets" v-model="cache.type" value="TARGETS" />
                    <label class="form-check-label" for="cacheTargets">เลือก Targets</label>
                  </div>
                </div>
              </div>

              <div v-if="cache.type === 'TARGETS'" class="col-md-12">
                <label class="form-label fw-bold">เลือก Targets ที่ต้องการ Clear</label>
                <div class="d-flex gap-3 flex-wrap">
                  <div class="form-check" v-for="t in cacheTargetOptions" :key="t.value">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'target_' + t.value"
                      :value="t.value"
                      v-model="cache.targets"
                    />
                    <label class="form-check-label" :for="'target_' + t.value">{{ t.label }}</label>
                  </div>
                </div>
                <div v-if="cache.type === 'TARGETS' && cache.targets.length === 0" class="text-danger mt-1">
                  <small>กรุณาเลือกอย่างน้อย 1 target</small>
                </div>
              </div>

              <div class="col-md-12">
                <div class="bg-light p-2 rounded mb-2" style="font-family: monospace; font-size: 13px;">
                  <span v-if="cache.type === 'ALL'">
                    POST /v1/utils/cache &nbsp; body: {}
                  </span>
                  <span v-else>
                    POST /v1/utils/cache &nbsp; body: { "targets": [{{ cache.targets.map(t => '"' + t + '"').join(', ') }}] }
                  </span>
                </div>
                <button
                  class="btn btn-warning"
                  @click="clearCache"
                  :disabled="cache.is_loading === 'Y' || (cache.type === 'TARGETS' && cache.targets.length === 0)"
                >
                  <span v-if="cache.is_loading === 'Y'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  <vue-feather v-else type="trash-2" size="16"></vue-feather>
                  Clear Cache
                </button>
              </div>

              <div v-if="cache.result_msg" class="col-md-12">
                <div :class="['alert', cache.result_ok ? 'alert-success' : 'alert-danger']">
                  {{ cache.result_msg }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section 2: Event Management -->
        <div class="card mb-4">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0"><b>2. จัดการข้อมูลกิจกรรม</b></h5>
              <button class="btn btn-success btn-sm compact-btn" @click="openEventModal(null)" disabled>
                <vue-feather type="plus-square" size="14"></vue-feather> เพิ่มกิจกรรม
              </button>
            </div>
          </div>
          <div class="card-body compact-user-section">
            <div class="row g-2 mb-3">
              <div class="col-md-2">
                <select class="form-select form-select-sm" v-model="eventSearch.key_search">
                  <option value="event_key">ค้นหาจาก event_key</option>
                  <option value="title">ค้นหาจาก ชื่อกิจกรรม</option>
                </select>
              </div>
              <div class="col-md-2">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="eventSearch.keyword"
                  :placeholder="eventSearch.key_search === 'event_key' ? 'เช่น: run2025' : 'เช่น: มาราธอน'"
                  @keyup.enter="searchEvents"
                />
              </div>
              <div class="col-md-2">
                <button class="btn btn-outline-primary btn-sm w-100 compact-btn" @click="searchEvents">
                  <vue-feather type="search" size="14"></vue-feather> ค้นหา
                </button>
              </div>
              <div class="col-md-2">
                <button class="btn btn-outline-secondary btn-sm w-100 compact-btn" @click="clearEventSearch">
                  <vue-feather type="x" size="14"></vue-feather> ล้างข้อมูล
                </button>
              </div>
            </div>

            <div v-if="eventSearch.is_loading === 'Y'" class="d-flex justify-content-center py-4">
              <img style="width: 50px" src="../../assets/images/running_loading.svg" />
            </div>

            <div v-if="eventSearch.is_loading === 'N'" class="table-responsive">
              <table class="table table-bordered table-hover table-sm compact-user-table">
                <thead class="table-light">
                  <tr>
                    <th style="width:50px">ID</th>
                    <th>Event Key</th>
                    <th>ชื่อกิจกรรม</th>
                    <th style="width:120px">วันที่กิจกรรม</th>
                    <th style="width:90px">สถานะ</th>
                    <th style="width:260px">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="eventSearch.results.length === 0">
                    <td colspan="6" class="text-center text-muted py-3">ไม่พบข้อมูล</td>
                  </tr>
                  <tr v-for="ev in eventSearch.results" :key="ev.id">
                    <td>{{ ev.id }}</td>
                    <td>{{ ev.event_key }}</td>
                    <td><router-link :to="'/' + ev.event_key" target="_blank"  title="หน้าระบบรับสมัครจริง">
                        {{ ev.title }}
                      </router-link></td>
                    <td>{{ toDateFormat(ev.event_date) }}</td>
                    <td>{{ ev.event_status }}</td>
                    <td>
                      
                      <router-link :to="'/dashboard-organizer/' + ev.event_key" target="_blank" class="btn btn-outline-warning compact-action-btn me-1" title="ดูรายงาน">
                        <vue-feather type="bar-chart-2" size="12"></vue-feather>
                      </router-link>
                      <router-link :to="'/dashboard-organizer/' + ev.event_key + '/edit'" target="_blank" class="btn btn-outline-primary compact-action-btn me-1">
                        <vue-feather type="edit-2" size="12"></vue-feather>
                      </router-link>
                      <button class="btn btn-outline-info compact-action-btn" @click="openCopyEventModal(ev)">
                        <vue-feather type="copy" size="12"></vue-feather>
                      </button>
                      <button class="btn btn-outline-success compact-action-btn ms-1" @click="openEventMappingModal(ev)">
                        <vue-feather type="users" size="12"></vue-feather>
                      </button>
                      <router-link
                        v-if="ev.is_enable_public_link === 'Y'"
                        :to="'/' + ev.event_key + '/realtime'"
                        target="_blank"
                        class="btn btn-outline-danger compact-action-btn ms-1"
                        title="Realtime Report"
                      >
                        <vue-feather type="activity" size="12"></vue-feather>
                      </router-link>
                      <button
                        v-else
                        class="btn btn-outline-danger compact-action-btn ms-1"
                        title="Realtime Report (ปิดใช้งาน public link)"
                        disabled
                      >
                        <vue-feather type="activity" size="12"></vue-feather>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Section 3: User Management -->
        <div class="card mb-4">
          <div class="card-header">
            <div class="header-top">
              <h5 class="m-0"><b>3. จัดการข้อมูลผู้ใช้งาน</b></h5>
              <button class="btn btn-success btn-sm compact-btn" @click="openUserModal(null)">
                <vue-feather type="user-plus" size="14"></vue-feather> เพิ่มผู้ใช้งาน
              </button>
            </div>
          </div>
          <div class="card-body compact-user-section">
            <!-- Search -->
            <div class="row g-2 mb-3">
              <div class="col-md-2">
                <select class="form-select form-select-sm" v-model="userSearch.key_search">
                  <option value="fname">ค้นหาจาก ชื่อ (fname)</option>
                  <option value="email">ค้นหาจาก Email</option>
                </select>
              </div>
              <div class="col-md-2">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="userSearch.keyword"
                  :placeholder="userSearch.key_search === 'fname' ? 'เช่น: สมชาย' : 'เช่น: admin@'"
                  @keyup.enter="searchUsers"
                />
              </div>
              <div class="col-md-2">
                <select class="form-select form-select-sm" v-model="userSearch.role">
                  <option value="">ทุก role</option>
                  <option value="runner">runner</option>
                  <option value="organizer">organizer</option>
                  <option value="ssadmin">ssadmin</option>
                </select>
              </div>
              <div class="col-md-2">
                <button class="btn btn-outline-primary btn-sm w-100 compact-btn" @click="searchUsers">
                  <vue-feather type="search" size="14"></vue-feather> ค้นหา
                </button>
              </div>
              <div class="col-md-2">
                <button class="btn btn-outline-secondary btn-sm w-100 compact-btn" @click="clearUserSearch">
                  <vue-feather type="x" size="14"></vue-feather> ล้างข้อมูล
                </button>
              </div>
            </div>

            <!-- Loading -->
            <div v-if="userSearch.is_loading === 'Y'" class="d-flex justify-content-center py-4">
              <img style="width: 50px" src="../../assets/images/running_loading.svg" />
            </div>

            <!-- Table -->
            <div v-if="userSearch.is_loading === 'N'" class="table-responsive">
              <table class="table table-bordered table-hover table-sm compact-user-table">
                <thead class="table-light">
                  <tr>
                    <th style="width:50px">ID</th>
                    <th>ชื่อ - นามสกุล</th>
                    <th>Email</th>
                    <th>เบอร์โทร</th>
                    <th>Role</th>
                    <th style="width:130px">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="userSearch.results.length === 0">
                    <td colspan="6" class="text-center text-muted py-3">ไม่พบข้อมูล</td>
                  </tr>
                  <tr v-for="u in userSearch.results" :key="u.id">
                    <td>{{ u.id }}</td>
                    <td>{{ u.fname }} {{ u.lname }}</td>
                    <td>{{ u.email }}</td>
                    <td>{{ u.mobile_no }}</td>
                    <td><span :class="['badge', 'compact-badge', u.role === 'ssadmin' ? 'bg-danger' : u.role === 'organizer' ? 'bg-warning text-dark' : 'bg-secondary']">{{ u.role }}</span></td>
                    <td>
                      <button class="btn btn-outline-primary compact-action-btn me-1" @click="openUserModal(u)">
                        <vue-feather type="edit-2" size="12"></vue-feather>
                      </button>
                      <button class="btn btn-outline-info compact-action-btn" @click="copyUserToAddNew(u)">
                        <vue-feather type="copy" size="12"></vue-feather>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-header">
            <div class="header-top">
              <h6 class="m-0"><b>รายการสถานะ Order และ Runner ไม่ตรงกัน</b></h6>
              <button
                class="btn btn-outline-primary btn-sm compact-btn"
                @click="loadOrderRunnerStatusMismatches"
                :disabled="orderRunnerStatusMismatches.is_loading === 'Y'"
              >
                <vue-feather type="refresh-cw" size="14"></vue-feather> รีเฟรช
              </button>
            </div>
          </div>
          <div class="card-body compact-user-section">
            <div v-if="orderRunnerStatusMismatches.is_loading === 'Y'" class="d-flex justify-content-center py-4">
              <img style="width: 50px" src="../../assets/images/running_loading.svg" />
            </div>

            <div v-else-if="orderRunnerStatusMismatches.error_msg" class="alert alert-danger py-2 mb-0">
              {{ orderRunnerStatusMismatches.error_msg }}
            </div>

            <div v-else class="table-responsive">
              <table class="table table-bordered table-hover table-sm compact-user-table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>UUID</th>
                    <th>Order Status</th>
                    <th>Runner Count</th>
                    <th>Runner Order UUID</th>
                    <th>Runner Status</th>
                    <th>Event Key</th>
                    <th style="width:90px">ลิงก์แก้ไข</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="orderRunnerStatusMismatches.results.length === 0">
                    <td colspan="7" class="text-center text-muted py-3">ไม่พบข้อมูลสถานะที่ไม่ตรงกัน</td>
                  </tr>
                  <tr
                    v-for="(item, index) in orderRunnerStatusMismatches.results"
                    :key="item.order_uuid + '-' + index"
                  >
                    <td>{{ item.uuid }}</td>
                    <td><span class="badge bg-primary compact-badge">{{ item.status }}</span></td>
                    <td class="text-center">{{ item.runner_count }}</td>
                    <td>{{ item.order_uuid }}</td>
                    <td><span class="badge bg-warning text-dark compact-badge">{{ item.order_status }}</span></td>
                    <td>{{ item.event_key }}</td>
                    <td class="text-center">
                      <a :href="item.link" target="_blank" rel="noopener noreferrer" title="เปิดหน้าแก้ไข Order">
                        <vue-feather type="external-link" size="14"></vue-feather>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div><!-- end is_authorization Y -->
    </div>
  </div>

  <!-- Modal: Add/Edit User -->
  <div class="modal fade" id="userModal" tabindex="-1" aria-hidden="true" ref="userModalEl">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ userForm.id ? 'แก้ไขผู้ใช้งาน' : 'เพิ่มผู้ใช้งาน' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">ชื่อ (fname)</label>
              <input type="text" class="form-control" v-model="userForm.fname" />
            </div>
            <div class="col-md-6">
              <label class="form-label">นามสกุล (lname)</label>
              <input type="text" class="form-control" v-model="userForm.lname" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Email <span class="text-danger">*</span></label>
              <input type="email" class="form-control" v-model="userForm.email" :disabled="!!userForm.id" />
            </div>
            <div class="col-md-6">
              <label class="form-label">เบอร์โทร (mobile_no)</label>
              <input type="text" class="form-control" v-model="userForm.mobile_no" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Role</label>
              <select class="form-select" v-model="userForm.role">
                <option value="runner">runner</option>
                <option value="organizer">organizer</option>
                <option value="ssadmin">ssadmin</option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Password {{ userForm.id ? '(แสดงค่าปัจจุบัน)' : '' }} <span v-if="!userForm.id" class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="userForm.password" autocomplete="new-password" />
            </div>
            <div v-if="userModal.error_msg" class="col-md-12">
              <div class="alert alert-danger py-2">{{ userModal.error_msg }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ยกเลิก</button>
          <button
            type="button"
            class="btn btn-primary"
            @click="saveUser"
            :disabled="userModal.is_saving === 'Y'"
          >
            <span v-if="userModal.is_saving === 'Y'" class="spinner-border spinner-border-sm me-1" role="status"></span>
            บันทึก
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Add/Edit Event -->
  <div class="modal fade" id="eventModal" tabindex="-1" aria-hidden="true" ref="eventModalEl">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ eventForm.id ? 'แก้ไขกิจกรรม' : 'เพิ่มกิจกรรม' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3 compact-user-section">
            <div class="col-md-6">
              <label class="form-label">Event Key <span class="text-danger">*</span></label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.event_key" />
            </div>
            <div class="col-md-6">
              <label class="form-label">ชื่อกิจกรรม <span class="text-danger">*</span></label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.title" />
            </div>
            <div class="col-md-3">
              <label class="form-label">วันที่จัดกิจกรรม</label>
              <input type="date" class="form-control form-control-sm" v-model="eventForm.event_date" />
            </div>
            <div class="col-md-3">
              <label class="form-label">เปิดรับสมัคร</label>
              <input type="datetime-local" class="form-control form-control-sm" v-model="eventForm.registration_start" />
            </div>
            <div class="col-md-3">
              <label class="form-label">ปิดรับสมัคร</label>
              <input type="datetime-local" class="form-control form-control-sm" v-model="eventForm.registration_end" />
            </div>
            <div class="col-md-3">
              <label class="form-label">สถานะ</label>
              <select class="form-select form-select-sm" v-model="eventForm.event_status">
                <option value="OPEN">OPEN</option>
                <option value="ACTIVE">ACTIVE</option>
                <option value="SOON">SOON</option>
                <option value="END">END</option>
                <option value="HIDE">HIDE</option>
              </select>
            </div>

            <div class="col-md-3">
              <label class="form-label">เปิดรับสมัคร (is_open_register)</label>
              <select class="form-select form-select-sm" v-model="eventForm.is_open_register">
                <option value="Y">Y</option>
                <option value="N">N</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Regions</label>
              <select class="form-select form-select-sm" v-model="eventForm.regions">
                <option value="">-</option>
                <option value="NORTH">NORTH</option>
                <option value="CENTER">CENTER</option>
                <option value="SOUTH">SOUTH</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Payment Method</label>
              <select class="form-select form-select-sm" v-model="eventForm.payment_method">
                <option value="DIRECT">DIRECT</option>
                <option value="OPN">OPN</option>
                <option value="FREE">FREE</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Payment Fee</label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.payment_fee" />
            </div>

            <div class="col-md-6">
              <label class="form-label">คำอธิบาย</label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.description" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Location</label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.location" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Website</label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.website" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Cover URL</label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.coverurl" />
            </div>

            <div class="col-md-3">
              <label class="form-label">ลำดับ</label>
              <input type="number" class="form-control form-control-sm" v-model.number="eventForm.sequence" />
            </div>
            <div class="col-md-3">
              <label class="form-label">สูงสุด/Order</label>
              <input type="number" class="form-control form-control-sm" v-model.number="eventForm.max_runner_register_per_order" />
            </div>
            <div class="col-md-3">
              <label class="form-label">จำกัดจำนวน</label>
              <select class="form-select form-select-sm" v-model="eventForm.is_limit_participate">
                <option value="Y">Y</option>
                <option value="N">N</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">จำนวนสูงสุด</label>
              <input type="number" class="form-control form-control-sm" v-model.number="eventForm.limit_participate" />
            </div>

            <div class="col-md-2">
              <label class="form-label">ระบบ Fee</label>
              <select class="form-select form-select-sm" v-model="eventForm.is_system_fee">
                <option value="Y">Y</option>
                <option value="N">N</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Fee Amt</label>
              <input type="number" step="0.01" class="form-control form-control-sm" v-model.number="eventForm.system_fee_amt" />
            </div>
            <div class="col-md-2">
              <label class="form-label">Coupon</label>
              <select class="form-select form-select-sm" v-model="eventForm.is_coupon">
                <option value="Y">Y</option>
                <option value="N">N</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Free Payment Fee</label>
              <select class="form-select form-select-sm" v-model="eventForm.is_free_payment_fee">
                <option value="Y">Y</option>
                <option value="N">N</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Production</label>
              <select class="form-select form-select-sm" v-model="eventForm.is_production_mode">
                <option value="Y">Y</option>
                <option value="N">N</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Cal Age</label>
              <select class="form-select form-select-sm" v-model="eventForm.cal_age_method">
                <option value="RACE_YEAR">RACE_YEAR</option>
                <option value="RACE_DATE">RACE_DATE</option>
              </select>
            </div>

            <div class="col-md-12">
              <label class="form-label">Content (TH)</label>
              <textarea class="form-control form-control-sm" rows="3" v-model="eventForm.content"></textarea>
            </div>
            <div class="col-md-12">
              <label class="form-label">Content (EN)</label>
              <textarea class="form-control form-control-sm" rows="3" v-model="eventForm.content_en"></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Organizer Info</label>
              <textarea class="form-control form-control-sm" rows="2" v-model="eventForm.organizer_info"></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Organizer Info EN</label>
              <textarea class="form-control form-control-sm" rows="2" v-model="eventForm.organizer_info_en"></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Condition</label>
              <textarea class="form-control form-control-sm" rows="2" v-model="eventForm.condition"></textarea>
            </div>
            <div class="col-md-6">
              <label class="form-label">Condition EN</label>
              <textarea class="form-control form-control-sm" rows="2" v-model="eventForm.condition_en"></textarea>
            </div>
            <div class="col-md-12">
              <label class="form-label">ข้อความหลังสมัครสำเร็จ</label>
              <input type="text" class="form-control form-control-sm" v-model="eventForm.txt_message_registed" />
            </div>
            <div class="col-md-12">
              <label class="form-label">Spacial Config (JSON/Text)</label>
              <textarea class="form-control form-control-sm" rows="2" v-model="eventForm.spacial_config"></textarea>
            </div>
            <div v-if="eventModal.error_msg" class="col-md-12">
              <div class="alert alert-danger py-2">{{ eventModal.error_msg }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ยกเลิก</button>
          <button type="button" class="btn btn-primary" @click="saveEvent" :disabled="eventModal.is_saving === 'Y'">
            <span v-if="eventModal.is_saving === 'Y'" class="spinner-border spinner-border-sm me-1" role="status"></span>
            บันทึก
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Copy Event (from Section 4) -->
  <div class="modal fade" id="copyEventModal" tabindex="-1" aria-hidden="true" ref="copyEventModalEl">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Copy Event: {{ copyEventModalData.event_key }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-md-12">
              <label class="form-label">Event Key ปลายทาง (event_key_to)</label>
              <input type="text" class="form-control" v-model="copyEventModalData.event_key_to" placeholder="เช่น EVENT2025" />
            </div>
            <div v-if="copyEventModalData.error_msg" class="col-md-12">
              <div class="alert alert-danger py-2">{{ copyEventModalData.error_msg }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ยกเลิก</button>
          <button
            type="button"
            class="btn btn-primary"
            @click="confirmCopyEvent"
            :disabled="copyEventModalData.is_copying === 'Y' || !copyEventModalData.event_key_to"
          >
            <span v-if="copyEventModalData.is_copying === 'Y'" class="spinner-border spinner-border-sm me-1" role="status"></span>
            Copy
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Event Organizer Mapping -->
  <div class="modal fade" id="eventMappingModal" tabindex="-1" aria-hidden="true" ref="eventMappingModalEl">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ผู้ดูแลกิจกรรม: {{ eventMappingModalData.event_key }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body compact-user-section">
          <div class="mb-2"><b>{{ eventMappingModalData.event_title }}</b></div>

          <div class="row g-3">
            <div class="col-md-6">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="form-label m-0">รายชื่อผู้ดูแล Event</label>
                <button class="btn btn-outline-secondary btn-sm" @click="loadEventMappings" :disabled="eventMappingModalData.list_loading === 'Y'">
                  รีเฟรช
                </button>
              </div>

              <div v-if="eventMappingModalData.list_loading === 'Y'" class="d-flex justify-content-center py-3">
                <span class="spinner-border spinner-border-sm" role="status"></span>
              </div>

              <div v-if="eventMappingModalData.list_error" class="alert alert-danger py-2">
                {{ eventMappingModalData.list_error }}
              </div>

              <div v-if="eventMappingModalData.list_loading === 'N'" class="table-responsive">
                <table class="table table-bordered table-sm compact-user-table">
                  <thead class="table-light">
                    <tr>
                      <th>ID</th>
                      <th>ชื่อ</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th style="width:70px">ลบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="eventMappingModalData.list.length === 0">
                      <td colspan="5" class="text-center text-muted">ยังไม่มีผู้ดูแล</td>
                    </tr>
                    <tr v-for="m in eventMappingModalData.list" :key="m.user_id || m.id">
                      <td>{{ m.user_id || m.id }}</td>
                      <td>{{ (m.fname || '') + ' ' + (m.lname || '') }}</td>
                      <td>{{ m.email || '-' }}</td>
                      <td>{{ m.role || '-' }}</td>
                      <td>
                        <button
                          class="btn btn-outline-danger compact-action-btn"
                          @click="deleteEventMapping(m)"
                          :disabled="eventMappingModalData.action_loading === 'Y'"
                        >
                          <vue-feather type="trash-2" size="12"></vue-feather>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">ค้นหา organizer เพื่อเพิ่ม</label>
              <div class="row g-2 mb-2">
                <div class="col-md-4">
                  <select class="form-select form-select-sm" v-model="eventMappingModalData.user_search_key">
                    <option value="fname">fname</option>
                    <option value="email">email</option>
                  </select>
                </div>
                <div class="col-md-5">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="eventMappingModalData.user_search_txt"
                    :placeholder="eventMappingModalData.user_search_key === 'fname' ? 'เช่น: สมชาย' : 'เช่น: organizer@'"
                    @keyup.enter="searchUsersForEventMapping"
                  />
                </div>
                <div class="col-md-3">
                  <button class="btn btn-outline-primary btn-sm w-100" @click="searchUsersForEventMapping" :disabled="eventMappingModalData.user_search_loading === 'Y'">
                    ค้นหา
                  </button>
                </div>
              </div>

              <div v-if="eventMappingModalData.user_search_loading === 'Y'" class="d-flex justify-content-center py-3">
                <span class="spinner-border spinner-border-sm" role="status"></span>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered table-sm compact-user-table">
                  <thead class="table-light">
                    <tr>
                      <th>ID</th>
                      <th>ชื่อ</th>
                      <th>Email</th>
                      <th style="width:80px">เพิ่ม</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="eventMappingModalData.user_search_results.length === 0">
                      <td colspan="4" class="text-center text-muted">ยังไม่มีผลลัพธ์</td>
                    </tr>
                    <tr v-for="u in eventMappingModalData.user_search_results" :key="u.id">
                      <td>{{ u.id }}</td>
                      <td>{{ (u.fname || '') + ' ' + (u.lname || '') }}</td>
                      <td>{{ u.email || '-' }}</td>
                      <td>
                        <button
                          class="btn btn-outline-success compact-action-btn"
                          @click="addEventMapping(u)"
                          :disabled="eventMappingModalData.action_loading === 'Y' || isMappedUser(u.id)"
                        >
                          <vue-feather type="plus" size="12"></vue-feather>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ปิด</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import welcomecard from "./user_welcomecard.vue";
import axios from "axios";
import { Modal } from "bootstrap";

export default {
  components: {
    welcomecard,
  },
  data() {
    return {
      is_authorization: null,
      token: null,

      // --- Cache ---
      cache: {
        type: "ALL",
        targets: [],
        is_loading: "N",
        result_msg: "",
        result_ok: false,
      },
      cacheTargetOptions: [
        { value: "events", label: "events" },
        { value: "order", label: "order" },
        { value: "runner", label: "runner" },
        { value: "organizer", label: "organizer" },
      ],

      // --- User Management ---
      userSearch: {
        keyword: "",
        key_search: "fname",
        role: "",
        limit: 20,
        offset: 0,
        is_loading: "N",
        results: [],
      },
      userForm: {
        id: null,
        fname: "",
        lname: "",
        email: "",
        mobile_no: "",
        role: "runner",
        password: "",
        old_password: "",
      },
      userModal: {
        is_saving: "N",
        error_msg: "",
        instance: null,
      },
      orderRunnerStatusMismatches: {
        is_loading: "N",
        error_msg: "",
        results: [],
      },

      // --- Event Management ---
      eventSearch: {
        keyword: "",
        key_search: "event_key",
        is_loading: "N",
        results: [],
      },
      eventForm: {
        id: null,
        event_date: "",
        registration_start: "",
        registration_end: "",
        title: "",
        event_key: "",
        coverurl: "",
        content: "",
        content_en: "",
        organizer_info: "",
        organizer_info_en: "",
        description: "",
        spacial_config: "",
        sequence: null,
        location: "",
        event_status: "ACTIVE",
        organizer_id: null,
        is_open_register: "Y",
        website: "",
        regions: "",
        payment_fee: "0.03",
        payment_method: "DIRECT",
        payment_account_no: "",
        payment_account_name: "",
        payment_bank_name: "",
        is_qrcode_scan: "N",
        qrcode_scan_url: "",
        validate_email: "Y",
        max_runner_register_per_order: 20,
        is_run_model: "Y",
        is_additional: "N",
        is_additional1: "N",
        is_additional1_require: "N",
        is_additional2: "N",
        is_additional2_require: "N",
        is_additional3: "N",
        is_additional3_require: "N",
        is_additional4: "N",
        is_additional4_require: "N",
        is_enable_checkbib_function: "N",
        condition: "N",
        condition_en: "N",
        is_system_fee: "N",
        system_fee_amt: 0,
        is_limit_participate: "N",
        limit_participate: 2000,
        is_require_health_problem: "N",
        is_require_blood_group: "Y",
        is_require_emergency_name: "Y",
        is_require_emergency_relation: "Y",
        is_require_emergency_mobile_no: "Y",
        cal_age_method: "RACE_YEAR",
        txt_message_registed: "คุณสมัครเป็นคนที่ {COUNT_RUNNER} และสมัครเป็นคนที่ {COUNT_RUNNER_BY_TYPE} ของรูปแบบการแเเข่งขันนี้ ({TYPE_NAME})",
        is_coupon: "N",
        is_production_mode: "Y",
        is_require_id_card: "Y",
        is_custom_field1: "N",
        is_custom_field1_require: "N",
        is_custom_field1_name: "",
        is_custom_field1_name_en: "",
        is_free_payment_fee: "N",
        is_organizer_can_change_run_type: "N",
        is_enable_refund: "N",
        is_participant_check: "N",
      },
      eventModal: {
        is_saving: "N",
        error_msg: "",
        instance: null,
      },

      copyEventModalData: {
        event_key: "",
        event_key_to: "",
        error_msg: "",
        is_copying: "N",
        instance: null,
      },

      eventMappingModalData: {
        event_key: "",
        event_title: "",
        list_loading: "N",
        list_error: "",
        list: [],
        user_search_key: "fname",
        user_search_txt: "",
        user_search_loading: "N",
        user_search_results: [],
        action_loading: "N",
        instance: null,
      },
    };
  },

  async mounted() {
    this.token = localStorage.getItem("_rr_token");
    if (this.token !== null) {
      await this.checkAuthorization();
    } else {
      this.$router.push("/auth/login");
    }
  },

  methods: {
    async checkAuthorization() {
      try {
        const headers = { Authorization: "Bearer " + this.token };
        const res = await axios.post("v1/auth/profile", null, { headers });
        if (res.status === 201) {
          const user = res.data && res.data.message ? res.data.message : res.data;
          if (user && user.role === "ssadmin") {
            this.is_authorization = "Y";
            await Promise.all([
              this.searchEvents(),
              this.loadOrderRunnerStatusMismatches(),
            ]);
          } else {
            this.is_authorization = "N";
          }
        } else {
          this.is_authorization = "N";
        }
      } catch (e) {
        this.is_authorization = "N";
      }
    },

    // --- CACHE ---
    async clearCache() {
      this.cache.is_loading = "Y";
      this.cache.result_msg = "";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const data = this.cache.type === "ALL" ? {} : { targets: this.cache.targets };
        const res = await axios.post("v1/utils/cache", data, { headers });
        if (res.data && res.data.status === "success") {
          this.cache.result_ok = true;
          this.cache.result_msg = "Clear Cache สำเร็จ";
        } else {
          this.cache.result_ok = false;
          this.cache.result_msg = "เกิดข้อผิดพลาด: " + (res.data.message || "unknown");
        }
      } catch (e) {
        this.cache.result_ok = false;
        this.cache.result_msg = "เกิดข้อผิดพลาด: " + (e.response?.data?.message || e.message);
      }
      this.cache.is_loading = "N";
    },

    // --- COPY EVENT ---
    // --- USER MANAGEMENT ---
    async searchUsers() {
      this.userSearch.is_loading = "Y";
      this.userSearch.results = [];
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const keyword = (this.userSearch.keyword || "").trim();
        const payload = {};

        if (keyword) {
          payload.key_search = this.userSearch.key_search;
          payload.txt_search = keyword;
          if (this.userSearch.role) {
            payload.role = this.userSearch.role;
          }
        } else {
          payload.limit = this.userSearch.limit;
          payload.offset = this.userSearch.offset;
          if (this.userSearch.role) {
            payload.role = this.userSearch.role;
          }
        }

        const res = await axios.post("v1/utils/user", payload, { headers });
        if (res.data && res.data.status === "success") {
          this.userSearch.results = res.data.body || [];
        }
      } catch (e) {
        this.userSearch.results = [];
      }
      this.userSearch.is_loading = "N";
    },

    clearUserSearch() {
      this.userSearch.keyword = "";
      this.userSearch.key_search = "fname";
      this.userSearch.role = "";
      this.userSearch.offset = 0;
      this.userSearch.results = [];
    },

    async loadOrderRunnerStatusMismatches() {
      this.orderRunnerStatusMismatches.is_loading = "Y";
      this.orderRunnerStatusMismatches.error_msg = "";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const res = await axios.post("v1/utils/order-runner-status-mismatches", {}, { headers });
        if (res.data && res.data.status === "success") {
          this.orderRunnerStatusMismatches.results = res.data.body || [];
        } else {
          this.orderRunnerStatusMismatches.results = [];
          this.orderRunnerStatusMismatches.error_msg =
            "เกิดข้อผิดพลาด: " + ((res.data && res.data.message) || "unknown");
        }
      } catch (e) {
        this.orderRunnerStatusMismatches.results = [];
        this.orderRunnerStatusMismatches.error_msg =
          "เกิดข้อผิดพลาด: " + ((e.response && e.response.data && e.response.data.message) || e.message);
      }
      this.orderRunnerStatusMismatches.is_loading = "N";
    },

    openUserModal(user) {
      this.userModal.error_msg = "";
      if (user) {
        this.userForm = {
          id: user.id,
          fname: user.fname || "",
          lname: user.lname || "",
          email: user.email || "",
          mobile_no: user.mobile_no || "",
          role: user.role || "runner",
          password: user.password || "",
          old_password: user.password || "",
        };
      } else {
        this.userForm = {
          id: null,
          fname: "",
          lname: "",
          email: "",
          mobile_no: "",
          role: "runner",
          password: "",
          old_password: "",
        };
      }
      if (!this.userModal.instance) {
        this.userModal.instance = new Modal(this.$refs.userModalEl);
      }
      this.userModal.instance.show();
    },

    copyUserToAddNew(user) {
      this.userModal.error_msg = "";
      this.userForm = {
        id: null,
        fname: user.fname || "",
        lname: user.lname || "",
        email: "",
        mobile_no: user.mobile_no || "",
        role: user.role || "runner",
        password: "",
        old_password: "",
      };
      if (!this.userModal.instance) {
        this.userModal.instance = new Modal(this.$refs.userModalEl);
      }
      this.userModal.instance.show();
    },

    async saveUser() {
      this.userModal.error_msg = "";
      if (!this.userForm.email) {
        this.userModal.error_msg = "กรุณากรอก Email";
        return;
      }
      if (!this.userForm.id && !this.userForm.password) {
        this.userModal.error_msg = "กรุณากรอก Password";
        return;
      }
      this.userModal.is_saving = "Y";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        let res;
        if (this.userForm.id) {
          const payload = {
            id: this.userForm.id,
            fname: this.userForm.fname,
            lname: this.userForm.lname,
            email: this.userForm.email,
            mobile_no: this.userForm.mobile_no,
            role: this.userForm.role,
          };
          if (this.userForm.password && this.userForm.password !== this.userForm.old_password) payload.password = this.userForm.password;
          res = await axios.post("v1/utils/user/update", payload, { headers });
        } else {
          res = await axios.post("v1/utils/user/create", {
            fname: this.userForm.fname,
            lname: this.userForm.lname,
            email: this.userForm.email,
            mobile_no: this.userForm.mobile_no,
            role: this.userForm.role,
            password: this.userForm.password,
          }, { headers });
        }
        if (res.data && res.data.status === "success") {
          this.userModal.instance.hide();
          await this.searchUsers();
        } else {
          this.userModal.error_msg = "เกิดข้อผิดพลาด: " + (res.data.message || "unknown");
        }
      } catch (e) {
        this.userModal.error_msg = "เกิดข้อผิดพลาด: " + (e.response?.data?.message || e.message);
      }
      this.userModal.is_saving = "N";
    },

    async searchEvents() {
      this.eventSearch.is_loading = "Y";
      this.eventSearch.results = [];
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        // POST /v1/utils/event/list - ดึงรายการ event, ค้นหา event_key/title, pagination
        let payload = {};
        if (this.eventSearch.keyword) {
          payload = {
            key_search: this.eventSearch.key_search,
            txt_search: this.eventSearch.keyword,
          };
        }
        const res = await axios.post("v1/utils/event/list", payload, { headers });
        if (res.data && res.data.status === "success") {
          this.eventSearch.results = res.data.body || [];
        }
      } catch (e) {
        this.eventSearch.results = [];
      }
      this.eventSearch.is_loading = "N";
    },

    clearEventSearch() {
      this.eventSearch.keyword = "";
      this.eventSearch.results = [];
      this.eventSearch.key_search = "event_key";
    },

    resetEventForm() {
      this.eventForm = {
        id: null,
        event_date: "",
        registration_start: "",
        registration_end: "",
        title: "",
        event_key: "",
        coverurl: "",
        content: "",
        content_en: "",
        organizer_info: "",
        organizer_info_en: "",
        description: "",
        spacial_config: "",
        sequence: null,
        location: "",
        event_status: "ACTIVE",
        organizer_id: null,
        is_open_register: "Y",
        website: "",
        regions: "",
        payment_fee: "0.03",
        payment_method: "DIRECT",
        payment_account_no: "",
        payment_account_name: "",
        payment_bank_name: "",
        is_qrcode_scan: "N",
        qrcode_scan_url: "",
        validate_email: "Y",
        max_runner_register_per_order: 20,
        is_run_model: "Y",
        is_additional: "N",
        is_additional1: "N",
        is_additional1_require: "N",
        is_additional2: "N",
        is_additional2_require: "N",
        is_additional3: "N",
        is_additional3_require: "N",
        is_additional4: "N",
        is_additional4_require: "N",
        is_enable_checkbib_function: "N",
        condition: "N",
        condition_en: "N",
        is_system_fee: "N",
        system_fee_amt: 0,
        is_limit_participate: "N",
        limit_participate: 2000,
        is_require_health_problem: "N",
        is_require_blood_group: "Y",
        is_require_emergency_name: "Y",
        is_require_emergency_relation: "Y",
        is_require_emergency_mobile_no: "Y",
        cal_age_method: "RACE_YEAR",
        txt_message_registed: "คุณสมัครเป็นคนที่ {COUNT_RUNNER} และสมัครเป็นคนที่ {COUNT_RUNNER_BY_TYPE} ของรูปแบบการแเเข่งขันนี้ ({TYPE_NAME})",
        is_coupon: "N",
        is_production_mode: "Y",
        is_require_id_card: "Y",
        is_custom_field1: "N",
        is_custom_field1_require: "N",
        is_custom_field1_name: "",
        is_custom_field1_name_en: "",
        is_free_payment_fee: "N",
        is_organizer_can_change_run_type: "N",
        is_enable_refund: "N",
        is_participant_check: "N",
      };
    },

    toDatetimeLocal(value) {
      if (!value) return "";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    toDateFormat(value) {
      if (!value) return "";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },

    openEventModal(eventItem) {
      this.eventModal.error_msg = "";
      this.resetEventForm();
      if (eventItem) {
        Object.keys(this.eventForm).forEach((key) => {
          if (eventItem[key] !== undefined && eventItem[key] !== null) {
            this.eventForm[key] = eventItem[key];
          }
        });
        if (this.eventForm.registration_start) {
          this.eventForm.registration_start = this.toDatetimeLocal(this.eventForm.registration_start);
        }
        if (this.eventForm.registration_end) {
          this.eventForm.registration_end = this.toDatetimeLocal(this.eventForm.registration_end);
        }
        if (this.eventForm.event_date) {
          this.eventForm.event_date = String(this.eventForm.event_date).substring(0, 10);
        }
      }
      if (!this.eventModal.instance) {
        this.eventModal.instance = new Modal(this.$refs.eventModalEl);
      }
      this.eventModal.instance.show();
    },

    openCopyEventModal(eventItem) {
      this.copyEventModalData.event_key = eventItem.event_key || "";
      this.copyEventModalData.event_key_to = "";
      this.copyEventModalData.error_msg = "";
      if (!this.copyEventModalData.instance) {
        this.copyEventModalData.instance = new Modal(this.$refs.copyEventModalEl);
      }
      this.copyEventModalData.instance.show();
    },

    async openEventMappingModal(eventItem) {
      this.eventMappingModalData.event_key = (eventItem && eventItem.event_key) || "";
      this.eventMappingModalData.event_title = (eventItem && eventItem.title) || "";
      this.eventMappingModalData.list = [];
      this.eventMappingModalData.list_error = "";
      this.eventMappingModalData.user_search_txt = "";
      this.eventMappingModalData.user_search_results = [];

      if (!this.eventMappingModalData.instance) {
        this.eventMappingModalData.instance = new Modal(this.$refs.eventMappingModalEl);
      }
      this.eventMappingModalData.instance.show();

      await this.loadEventMappings();
    },

    isMappedUser(userId) {
      const uid = String(userId || "");
      return this.eventMappingModalData.list.some((m) => String(m.user_id || m.id || "") === uid);
    },

    async loadEventMappings() {
      if (!this.eventMappingModalData.event_key) return;
      this.eventMappingModalData.list_loading = "Y";
      this.eventMappingModalData.list_error = "";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const res = await axios.post("v1/utils/event-mapping/list", {
          event_key: this.eventMappingModalData.event_key,
        }, { headers });

        if (res.data && res.data.status === "success") {
          this.eventMappingModalData.list = res.data.body || [];
        } else {
          this.eventMappingModalData.list = [];
          this.eventMappingModalData.list_error = "เกิดข้อผิดพลาด: " + ((res.data && res.data.message) || "unknown");
        }
      } catch (e) {
        this.eventMappingModalData.list = [];
        this.eventMappingModalData.list_error = "เกิดข้อผิดพลาด: " + (e.response?.data?.message || e.message);
      }
      this.eventMappingModalData.list_loading = "N";
    },

    async searchUsersForEventMapping() {
      this.eventMappingModalData.user_search_loading = "Y";
      this.eventMappingModalData.user_search_results = [];
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const keyword = (this.eventMappingModalData.user_search_txt || "").trim();
        const payload = keyword
          ? {
            key_search: this.eventMappingModalData.user_search_key,
            txt_search: keyword,
            role: "organizer",
          }
          : {
            role: "organizer",
            limit: 20,
            offset: 0,
          };
        const res = await axios.post("v1/utils/user", payload, { headers });
        if (res.data && res.data.status === "success") {
          this.eventMappingModalData.user_search_results = res.data.body || [];
        }
      } catch (e) {
        this.eventMappingModalData.user_search_results = [];
      }
      this.eventMappingModalData.user_search_loading = "N";
    },

    async addEventMapping(user) {
      if (!user || !user.id || !this.eventMappingModalData.event_key) return;
      this.eventMappingModalData.action_loading = "Y";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const res = await axios.post("v1/utils/event-mapping/add", {
          event_key: this.eventMappingModalData.event_key,
          user_id: user.id,
        }, { headers });
        if (res.data && res.data.status === "success") {
          await this.loadEventMappings();
        } else {
          this.eventMappingModalData.list_error = "เกิดข้อผิดพลาด: " + ((res.data && res.data.message) || "unknown");
        }
      } catch (e) {
        this.eventMappingModalData.list_error = "เกิดข้อผิดพลาด: " + (e.response?.data?.message || e.message);
      }
      this.eventMappingModalData.action_loading = "N";
    },

    async deleteEventMapping(mappingItem) {
      const userId = mappingItem && (mappingItem.user_id || mappingItem.id);
      if (!userId || !this.eventMappingModalData.event_key) return;
      this.eventMappingModalData.action_loading = "Y";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const res = await axios.post("v1/utils/event-mapping/delete", {
          event_key: this.eventMappingModalData.event_key,
          user_id: userId,
        }, { headers });
        if (res.data && res.data.status === "success") {
          await this.loadEventMappings();
        } else {
          this.eventMappingModalData.list_error = "เกิดข้อผิดพลาด: " + ((res.data && res.data.message) || "unknown");
        }
      } catch (e) {
        this.eventMappingModalData.list_error = "เกิดข้อผิดพลาด: " + (e.response?.data?.message || e.message);
      }
      this.eventMappingModalData.action_loading = "N";
    },

    async confirmCopyEvent() {
      if (!this.copyEventModalData.event_key_to) return;
      this.copyEventModalData.is_copying = "Y";
      this.copyEventModalData.error_msg = "";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const res = await axios.post("v1/utils/copy-event", {
          event_key_from: this.copyEventModalData.event_key,
          event_key_to: this.copyEventModalData.event_key_to,
        }, { headers });
        if (res.data && res.data.status === "success") {
          this.copyEventModalData.instance.hide();
          await this.searchEvents();
        } else {
          this.copyEventModalData.error_msg = "เกิดข้อผิดพลาด: " + (res.data.message || "unknown");
        }
      } catch (e) {
        this.copyEventModalData.error_msg = "เกิดข้อผิดพลาด: " + ((e.response && e.response.data && e.response.data.message) || e.message);
      }
      this.copyEventModalData.is_copying = "N";
    },

    async saveEvent() {
      this.eventModal.error_msg = "";
      if (!this.eventForm.event_key || !this.eventForm.title) {
        this.eventModal.error_msg = "กรุณากรอก Event Key และชื่อกิจกรรม";
        return;
      }
      this.eventModal.is_saving = "Y";
      try {
        const headers = {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json",
        };
        const payload = {
          ...this.eventForm,
          registration_start: this.eventForm.registration_start || null,
          registration_end: this.eventForm.registration_end || null,
        };
        let res;
        if (this.eventForm.id) {
          // POST /v1/utils/event/update - แก้ไข event (ส่งเฉพาะ field ที่เปลี่ยน)
          res = await axios.post("v1/utils/event/update", payload, { headers });
        } else {
          // POST /v1/utils/event/create - สร้าง event ใหม่ (required: event_key, event_date, title)
          res = await axios.post("v1/utils/event/create", payload, { headers });
        }
        if (res.data && res.data.status === "success") {
          this.eventModal.instance.hide();
          await this.searchEvents();
        } else {
          this.eventModal.error_msg = "เกิดข้อผิดพลาด: " + ((res.data && res.data.message) || "unknown");
        }
      } catch (e) {
        this.eventModal.error_msg = "เกิดข้อผิดพลาด: " + ((e.response && e.response.data && e.response.data.message) || e.message);
      }
      this.eventModal.is_saving = "N";
    },
  },
};
</script>

<style scoped>
.compact-user-section {
  font-size: 13px;
}

.compact-user-table th,
.compact-user-table td {
  padding: 0.35rem 0.45rem;
  font-size: 12px;
  vertical-align: middle;
}

.compact-action-btn {
  padding: 0.03rem 0.075rem;
  line-height: 1;
  min-width: 7px;
  min-height: 6px;
}

.compact-action-btn .feather {
  width: 3px;
  height: 3px;
}

.compact-badge {
  font-size: 10px;
}

.compact-btn {
  font-size: 12px;
  padding: 0.2rem 0.5rem;
}
</style>
